import React, { useState, useEffect, useRef } from 'react';
import Table from '../Common/table';
import axios from '../httpServices/httpService';
import api from '../config.json'
import swal from 'sweetalert';
import auth from '../httpServices/authService';
import validation from '../utill/validation';
import _, { cloneDeep, result } from 'lodash';
import joi, { object } from 'joi'
import Loading from '../utill/LoadingComponent';
import date from '../utill/dateTime';
// import EquipmentSelection from '../Common/equipmentSelection';
import { ToastContainer, toast } from 'react-toastify';
import DateSelection from '../Common/DateSelection';
import { Button, Modal, Select } from 'antd';
import 'antd/dist/antd.css';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile, faMinusCircle, faPlusCircle, faThumbsDown, faThumbsUp } from '@fortawesome/free-solid-svg-icons';
import logo from '../assets/vg.png';
import ExportPdfButton from '../utill/ExportPdf';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import ImageView from '../ImageView/ImageView';
import PaginationComponent from '../Common/PaginationComponent';
import SelectComponent from '../Common/SelectComponent';


const QMSReportApproval = ({ handleDownloadTableToExcel, equips, equipGroups, fromDateLimit, getRightsForAccess, Heading }) => {

  const [qualityData, setQualityData] = useState([])
  const [inputData, setInputData] = useState({ From: new Date(), Till: new Date() })
  const [parts, setAllParts] = useState([]);
  const [allPartsCache, setAllPartsCache] = useState([]);
  const [types, setAllTypes] = useState([]);
  const [checkPointTemplates, setCheckPointTemplates] = useState([]);
  const [querySuccess, setQuerySuccess] = useState(false);
  const [sortColumn, setSortColumn] = useState({ path: 'PartID', order: 'asc' })
  const [open, setOpen] = useState(false);
  const [reportData, setReportData] = useState({});
  const [selectedTemplates, setSelectedTemplate] = useState({ Columns: [] })
  const [selectedConfig, setSelectedConfig] = useState({})
  const [selectedItem, setSelectedItem] = useState({})

  const [loader, setLoader] = useState(false)
  const [methods, setMethods] = useState([])
  const [arrayLenght, setArrayLenght] = useState(0);
  const customerRef = useRef(null);
  // const filteredOptions = clients.filter((o) => !selectedItems.find(b => o.label == b));
  const [ApprovalRemarks, setApprovalRemarks] = useState("")
  const [CurrentPage, setCurrentPage] = useState(1);
  const [TotalPage, setTotalPage] = useState(5);
  const [PageSize, setPageSize] = useState(25);
  const [currentChecksheet, setCurrentChecksheet] = useState([])

  const reportType = [
    // { label: "Incoming Inspection", value: "Incoming Inspection", name: "IncomingInspection" },
    // { label: "First Part Inspection", value: "First Part Inspection", name: "FirstPartInspection" },
    // { label: "Inprocess Inspection", value: "Inprocess Inspection", name: "InProcessInspection" },
    // { label: "Last Part Inspection", value: "Last Part Inspection", name: "LastPartInspection" },
    // { label: "FinishedGoods Inspection", value: "FinishedGoods Inspection", name: 'FG_Inspection' }
  ]

  useEffect(() => {
    Heading('Approve Reports')
    GetAllInspetcionTypes()
    getAllTemplate();
    getAllPart();
    getAllMethods();
  }, [])

  useEffect(() => {
    setLoader(true)
    axios.get(api.api + "item")
      .then((result) => {
        setLoader(false)
        const filterd = result.data.filter(item => item.ItemName === reportData.Item && item.ItemNumber === reportData.ItemNumber && item.Operation === reportData.Operation)
        if (filterd.length > 0 && reportData.InspectionType) {
          const inspect = filterd[0].Inspection.find(x => x.InspectionName == reportData.InspectionType)
          if (inspect) {
            setCurrentChecksheet(inspect?.checkSheetTitle)
          }
        }
      })
      .catch((err) => {
        setQuerySuccess(false)
      })
  }, [reportData, inputData])
  const demoFromHTML = async () => {
    const source = customerRef.current;
    const canvas = await html2canvas(source);
    const imgData = canvas.toDataURL('image/png');

    const pdf = new jsPDF('p', 'pt', 'letter', true);
    const imgProps = pdf.getImageProperties(imgData);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();

    const margin = 0.02; // 2% margin
    const marginWidth = pdfWidth * margin;
    const marginHeight = pdfHeight * margin;

    const availableWidth = pdfWidth - 2 * marginWidth;
    const availableHeight = (imgProps.height * availableWidth) / imgProps.width;

    pdf.addImage(
      imgData,
      'PNG',
      marginWidth,
      marginHeight,
      availableWidth,
      availableHeight > pdfHeight - 2 * marginHeight ? pdfHeight - 2 * marginHeight : availableHeight
    );

    pdf.save('Test.pdf');
  };



  const handleOnChange = (name, value) => {
    const obj = { ...inputData }
    obj[name] = value;
    setInputData(obj);
    console.log(obj);
  }

  const getAllMethods = () => {
    axios.get(api.api + "method")
      .then((result) => {
        setMethods(result.data)
      })
      .catch((err) => {
        console.log(err, "Error")
      })
  }


  const getAllTemplate = () => {
    axios.get(api.api + "checkPointConfig")
      .then((result) => {
        setCheckPointTemplates(result.data)
      })
      .catch((err) => {
        console.log(err, "Error")
      })
  }

  const getAllPart = () => {
    axios.get(api.api + "item")
      .then((result) => {
        setAllPartsCache(result.data)
        const all = result.data.map((one) => { return { label: one.ItemName, value: one.ItemName } })
        setAllParts(all)
      })
      .catch((err) => {
        console.log(err, "Error")
      })
  }

  useEffect(() => {
    if (inputData.From && inputData.Till && inputData.InspectionType && inputData.InspectionType.length > 0 &&
      inputData.ItemName && inputData.ItemName.length > 0 && inputData.ItemNumber && inputData.ItemNumber.length > 0) {
      handleGetData()
    }
  }, [CurrentPage, PageSize, inputData]);




  const handleGetData = async () => {
    // inputData.Clients = selectedItems.includes("All") ? clients : clients.filter(one => selectedItems.includes(one.label));
    setLoader(true)
    axios.put(api.api + 'checkSheetDataEntryForApproval', { query: inputData, PageSize: PageSize, Page: CurrentPage })
      .then((result) => {
        setLoader(false)
        setTotalPage(Math.ceil(result.data.totalDocument / PageSize));
        setQualityData(result.data.data);
        //setArrayLenght(result.data.length > 0 ? result.data[0].Reports.length : 0)
        console.log(result.data, "-----------------");
      })
      .catch((err) => {
        setLoader(false)
        console.log(err);
      })
  }




  const handleInputChange = (parentIdx, index, e) => {
    const data = { ...qualityData };
    data[parentIdx].Standard[index][e.currentTarget.name] = e.currentTarget.value;

    setQualityData(qualityData)
  }
  const handleApproval = (state) => {
    const message = (state == "Closed" ? "You Have Approved The Inspection " : "You Have Reffer Back The Inspection ")
    const warnMsg = (state == "Closed" ? "Are you sure you want to Approve the inspection?" : "Are you sure you want to Reffer Back the inspection?")
    swal({
      title: warnMsg,
      // text: `${err.response.data.message}`,
      icon: "warning",
      buttons: true,
      dangerMode: true
    }).then(WillApprove => {
      if (WillApprove) {
        axios.put(api.api + "checkSheetDataEntry", { ApprovalRemarks: ApprovalRemarks, id: reportData._id, State: state })
          .then((result) => {
            if (result.status == 200) {
              handleGetData()
              setOpen(false)
              toast.success(message, {
                position: 'top-right',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                style: {
                  backgroundColor: 'green',
                  color: 'white',
                },
              });
            }


          })
          .catch((err) => {
            if (err.response && err.response.data) {
              swal(err.response.data.message, { dangerMode: true })
            } else {
              swal(`${err}`, { dangerMode: true })
            }
          })
      }
      else {
        // Handle Cancel button click
        toast.success(`You Have Rejected The Inspection `, {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: {
            backgroundColor: 'red',
            color: 'white',
          },
        });
        console.log('Cancelled');
      }
    });


  }


  const columns1 = [
    { path: "DateTime", label: "Date", content: (obj) => (<>{moment(obj.DateTime).format('DD-MM-YY')}</>) },
    { path: "Item", label: "Item Name" },
    { path: "OkParts", label: "OkParts" },
    { path: "QtyInspected", label: "Qty Inspected" },
    { path: "QtyToInspect", label: "Qty To Inspect" },

    // {
    //   key: "InspectionData",
    //   label: <table class="table table-bordered mb-0 m-0 p-0">
    //     <thead>
    //       <tr>
    //         {[...Array(arrayLenght)].map((item, index) => (<>
    //           <th colSpan={3}>{'Sample ' + (index + 1)}</th>
    //         </>))}
    //       </tr>
    //     </thead>
    //   </table>,
    //   content: (obj) => (
    //     <React.Fragment>
    //       <table class="table table-bordered">
    //         <thead>
    //           {/* <tr>
    //                 {[...Array(obj.InspectionData[0].InspectionData.length)].map((item,index) => (<>
    //                   <th  colSpan={3}>{'Sample '+(index+1) }</th>
    //                   </> ))}
    //                    </tr> */}
    //           <tr>
    //             {/* { obj.InspectionData.length > 0 && [...Array(obj.InspectionData[0].InspectionData.length)].map((item,index) => (<>
    //                  <th  >Observation</th ><th  >Result</th ><th  >Remarks</th >
    //                   </> ))} */}
    //           </tr>
    //         </thead>
    //         {/* <tbody >
    //                 {obj.InspectionData.map((item,index) => (<tr>
    //                   {item.InspectionData.map((one,idx)=><> <td>{one.ObservedValue}</td><td style={{backgroundColor:`${reportData.Checksheet[index].Data[parentIdx].Result==='NA' ?'#FFA500':(reportData.Checksheet[index].Data[parentIdx].Result==='NG') ?'red':'#28A745'}`}}>{reportData.Checksheet[index].Data[parentIdx].Result}</td><td>{one.Remarks}</td></>)}
    //                   </tr> ))}
    //               </tbody> */}
    //       </table>
    //     </React.Fragment>
    //   ),
    // },
    {
      key: "State",
      label: "State",
      content: (obj) => (
        <React.Fragment>
          {obj.State == "PendingApproval" ? "Approval Pending" : obj.State}
        </React.Fragment>
      ),
    },
    {
      key: "view",
      label: "Approval",
      content: (obj) => (
        <React.Fragment>
          {obj.State == 'PendingApproval' && <button disabled={!getRightsForAccess('DynamicDataRights', "InspectionApproval", "write")} className='btn btn-sm btn-secondary' onClick={() => {
            const part = allPartsCache.find((part) => part.ItemName == obj.Item && part.ItemNumber == obj.ItemNumber && part.Operation == obj.Operation)
            if (part) {
              const checkSheet = part.Inspection.find(x => x.InspectionName == obj.InspectionType)
              const template = checkPointTemplates.filter(x => checkSheet.checkSheetTitle.some(c => c.TemplateName == x.Name))
              const obj1 = types.find(x => x.name == obj.InspectionType) || {}
              setSelectedConfig(obj1.obj || {})
              setSelectedItem(part || {})
              setSelectedTemplate(template)
            }
            setReportData(obj);
            setOpen(true)
          }}>
            Approval

          </button>}
        </React.Fragment>
      ),
    },
  ];

  const GetAllInspetcionTypes = () => {
    axios.get(api.api + 'customInspection')
      .then((result) => {
        const reports = [...reportType]
        result.data.forEach((one) => {
          const obj = { label: one.InspectionType, value: one.InspectionType, name: one.InspectionType, obj: one }
          reports.push(obj)
        })
        setAllTypes(reports)
      })
      .catch((err) => {
        console.log(err);
      })
  }


  // Array to track printed SetNames, move it outside map to persist across iterations
  let printedSetNames = [];

  const renderSetName = (sample) => {
    // If SetName hasn't been printed, print it and add it to the array
    if (!printedSetNames.includes(sample.SetName)) {
      printedSetNames.push(sample.SetName);
      if (sample.SetName) {
        return <h4 style={{ fontSize: 15, marginTop: 15 }}>Set Name - {sample.SetName}</h4>;
      }
      return <></>
    }
    // Otherwise, return null to avoid duplicate printing
    return null;
  };

  const getNextSample = (input) => {
    // Separate the string and number
    const match = input.match(/([a-zA-Z]+)(\d+)/);

    if (match) {
      const stringPart = match[1]; // "Sample"
      const numberPart = parseInt(match[2], 10); // 1

      // Increment the number
      const incrementedNumber = numberPart + 1;

      // Combine the string part with the incremented number
      return numberPart; // "Sample2"
    } else {
      return 0; // Return the original input if no match is found
    }
  }

  function openBase64InNewTab(base64String, fileType = 'application/pdf') {
    // Create a new window or tab with the base64 data
    const newTab = window.open();
    let content = '';
    // Format the base64 string as a data URL with the correct MIME type
    if (base64String.startsWith("data:image/")) {
      content = `<img src="${base64String}" style="width:100%; height:100%; border:none;" />`;
    } else {
      content = `
        <iframe 
          src=${base64String}
          style="border:none; width:100%; height:100%;" 
        ></iframe>
      `;
    }
    newTab.document.write(content);
  }

  const getColumns = (TemplateName) => checkPointTemplates.find(x => x.Name == TemplateName) ? checkPointTemplates.find(x => x.Name == TemplateName).Columns.filter(x => x.EnableForDataEntry) : [];
  const getColumnsAll = (TemplateName) => checkPointTemplates.find(x => x.Name == TemplateName) ? checkPointTemplates.find(x => x.Name == TemplateName).Columns : [];


  const AccordianComp = (sheet, id) => {
    const { Drawing, check_sheet_title } = sheet
    const panelId = `panel-${id}`; // Unique ID for the panel
    const headerId = `header-${id}`; // Unique ID for the header
    return (
      <div className="accordion-item border-0">
        <h2 style={{ width: '99%', padding: '12px' }} className="accordion-header" id={headerId}>
          <button
            style={{
              "border": "solid 1px lightgray",
              borderRadius: 10
            }}
            className="accordion-button"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target={`#${panelId}`} // Target the unique panel ID
            aria-expanded="false"
            aria-controls={panelId}
          >
            {check_sheet_title}
          </button>
        </h2>
        <div
          style={{ paddingBottom: '34px' }}
          id={panelId}
          className="accordion-collapse collapse show"
          aria-labelledby={headerId}
          data-bs-parent="#accordionParent" // Ensures only one is open at a time
        >
          <div className="accordion-body">
            {Drawing && <img width={'100%'} height={600} src={Drawing} title='drawing' />}
            {renderComponent(sheet, id)}
          </div>
        </div>
      </div>
    );
  };

  const renderComponent = (check, checkIdx) => {
    return <> {reportData && reportData.sampleRef && reportData.sampleRef.filter(x => x.CheckSheetName == check.check_sheet_title).map((sample, parentIdx) => {
      return <React.Fragment>
        {renderSetName(sample)}
        <h4 style={{ fontSize: 15, marginTop: 15 }}>Sample Serial :{selectedConfig.SampleSerial == "Auto" && selectedConfig.SampleSerialUnique == "No" ? "Sample #" + (parentIdx + 1) : getNextSample(sample.Sample)}
         {sample.IsNA?`    -  Not Applicable ( Remarks ) : ${sample.IsNARemarks} `: ""}
        </h4>
        <table style={{ tableLayout: 'auto', display: 'table' }} className="small table-sm table-responsive">
          <thead className='text-center'>
            <tr>
              {getColumns(check.TemplateName).filter(x => !x.DataType.startsWith("UserInput")).map((x) => <th>{x.FieldName}</th>)}
              {/* <th>Result</th> */}
              {getColumns(check.TemplateName).filter(x => x.DataType.startsWith("UserInput")).map((field) => {
                const isExistColums = reportData.Checksheet.filter(x => x.CheckSheetName == check.check_sheet_title).some((x) => x.Data[parentIdx] && x.Data[parentIdx][field.DbFieldName])
                if (isExistColums) {
                  return <th>{field.FieldName}</th>
                }
                return <></>
              })}
            </tr>
          </thead>
          <tbody>
            {currentChecksheet[checkIdx] && currentChecksheet[checkIdx].checkpoints.map((one, index) => {
              const color = selectedConfig.ResultConfigure.find(x => x.TreatAs == reportData.Checksheet.filter(a => a.CheckSheetName == check.check_sheet_title)[index]?.Data[parentIdx]?.Result)
              return (
                <tr style={
                  { backgroundColor: color ? color.Color : "yellow", padding: 0 }
                } key={index}>
                  {getColumns(check.TemplateName).filter(x => !x.DataType.startsWith("UserInput")).map((x) => <td>
                    <div
                      style={{
                        textAlign: "center",
                        fontWeight: "600",
                        whiteSpace: "pre-wrap",
                        padding: 5,
                        pointerEvents: "none",
                        backgroundColor:
                          "#e9ecef",
                        borderRadius: "5px",
                      }}
                    >
                      {one[x.DbFieldName] || "-"}
                    </div>
                  </td>)}

                  {getColumns(check.TemplateName).filter(x => x.DataType.startsWith("UserInput")).map((x => {
                    return reportData.Checksheet.filter(a => a.CheckSheetName == check.check_sheet_title)[index]?.Data[parentIdx]?.[x.DbFieldName] &&
                      <td>
                        <input
                          type="text"
                          disabled={true}
                          placeholder="enter remarks"
                          className="form-control form-control-sm"
                          name="Remarks"
                          style={{ padding: 0 }}
                          value={reportData.Checksheet.filter(a => a.CheckSheetName == check.check_sheet_title)[index] && reportData.Checksheet.filter(a => a.CheckSheetName == check.check_sheet_title)[index]?.Data[parentIdx]?.[x.DbFieldName]}
                        />
                      </td>
                  }))}
                  {one.StandardType == "Description" && <td>
                    <input
                      type="text"
                      disabled={true}
                      placeholder="enter remarks"
                      className="form-control form-control-sm"
                      name="Remarks"
                      style={{ padding: 0 }}
                      value={reportData.Checksheet.filter(a => a.CheckSheetName == check.check_sheet_title)[index] && reportData.Checksheet.filter(a => a.CheckSheetName == check.check_sheet_title)[index]?.Data[parentIdx]?.Result}
                    />
                  </td>}
                </tr>
              );
            })}

          </tbody>

        </table>
        <div className='text-center'><div className='p-2 text-white fw-bold' style={{ backgroundColor: `${sample.Value === 'OK' ? 'green' : 'red'}` }}> Result : {sample.Value}</div></div>
        {(reportData.sampleRef.length - 1) == parentIdx && <div className=''> Approval Remarks  : <input
          type="text"
          // disabled={true}
          placeholder="enter remarks"
          className="form-control form-control-sm"
          name="ApprovalRemarks"
          style={{ padding: 0 }}

          value={ApprovalRemarks}
          onChange={(e) =>
            setApprovalRemarks(e.target.value)
          }
        />
        </div>}
      </React.Fragment>
    })}</>
  }
  return (
    <React.Fragment>
      <ToastContainer />
      {loader ? <Loading labelShow={true} label={"Loading..."} /> : ''}
      {/* <div className='text-center' >
        <p >Inspection Approval</p>
      </div> */}
      <div className="row">
        <div className="col-sm-3">
          <div className="form-group ">
            <label className='small'>From</label>
            <input value={moment(inputData.From).format('YYYY-MM-DD')} className='form-control form-control-sm' onChange={(e) => handleOnChange('From', e.currentTarget.value)} type='date' />

          </div>
        </div>
        <div className="col-sm-3">
          <div className="form-group">
            <label className='small'>Till</label>
            <input value={moment(inputData.Till).format('YYYY-MM-DD')} className='form-control form-control-sm' onChange={(e) => handleOnChange('Till', e.currentTarget.value)} type='date' />

          </div>
        </div>
        <div className='col-sm-3'>
          <label className='small text-center'>Inspection Type</label>
          <SelectComponent
            defaultAll={true}
            name={"InspectionType"}
            types={types}
            inputData={inputData}
            handleOnChange={(value) => {
              handleOnChange('InspectionType', value)
            }}
          />
          {/* <Select
            // maxTagCount='responsive'
            //mode="multiple"
            placeholder="Select Inspection Type"
            value={inputData.InspectionType}
            onChange={(values) => {
              handleOnChange('InspectionType', values)
            }}
            style={{ width: '100%' }}
            options={types}
          /> */}
        </div>
        <div className='col-sm-3'>
          <label className='small text-center'>Item</label>
          <SelectComponent
            defaultAll={true}
            name={"ItemName"}
            types={_.uniqBy(allPartsCache.filter(x => x.Inspection.some(ins => ins.Enable && inputData?.InspectionType?.includes(ins.InspectionName))).map(x => { return { label: x.ItemName, value: x.ItemName } }), "value")}
            inputData={inputData}
            handleOnChange={(value) => {
              handleOnChange('ItemName', value)
            }}
          />

          {/* <Select
            // maxTagCount='responsive'
            // mode="multiple"
            placeholder="Select ItemName"
            value={inputData.ItemName || []}
            onChange={(values) => {
              handleOnChange('ItemName', values)
            }}
            style={{ width: '100%' }}
            options={_.uniqBy(allPartsCache.filter(x => x.Inspection.some(ins => ins.Enable && inputData?.InspectionType?.includes(ins.InspectionName))).map(x => { return { label: x.ItemName, value: x.ItemName } }), "value")}
          /> */}
        </div>
        <div className='col-sm-3'>
          <label className='small text-center'>Item Number</label>
          <SelectComponent
            defaultAll={true}
            name={"ItemNumber"}
            types={_.uniqBy(allPartsCache.filter(x => inputData?.ItemName?.includes(x.ItemName) && x.Inspection.some(ins => ins.Enable && inputData?.InspectionType?.includes(ins.InspectionName))).map(x => { return { label: x.ItemNumber, value: x.ItemNumber } }), "value")}
            inputData={inputData}
            handleOnChange={(value) => {
              handleOnChange('ItemNumber', value)
            }}
          />
          {/* <Select
            // maxTagCount='responsive'
            // mode="multiple"
            placeholder="Select Item Number"
            value={inputData.ItemNumber || []}
            onChange={(values) => {
              handleOnChange('ItemNumber', values)
            }}
            style={{ width: '100%' }}
            options={_.uniqBy(allPartsCache.filter(x => x.ItemName == inputData.ItemName && x.Inspection.some(ins => ins.Enable && inputData?.InspectionType?.includes(ins.InspectionName))).map(x => { return { label: x.ItemNumber, value: x.ItemNumber } }), "value")}
          /> */}
        </div>

        <div className="col-sm-1">
          <button className='btn btn-primary btn-sm mt-4' onClick={() => handleGetData()}>Apply</button>
        </div>
        {/* {reportData &&  reportData.Checksheet && reportData.Checksheet.length>0 && <ExportPdfButton reportData={reportData }/>} */}
        <Modal
          title={
            <div >
              <div className='flex'>
                <div> {'Item Name: ' + reportData.Item}</div>

                <div className='d-flex text-center'><div className='mx-1 border bg-info-subtle '><div>{reportData && reportData.QtyInspected
                }</div><div>Inspected</div></div><div className='mx-1 border bg-info-subtle'><div>{reportData && reportData.QtyToInspect}</div>To Inspect<div></div></div></div>
              </div>
              <div className='mt-3'>
                <div className='row'>
                  <div className='col-sm-3'>
                    Reference Docs :
                  </div>

                  {selectedItem && selectedItem.RefDocs && selectedItem.RefDocs.map((ref) => {
                    return (
                      <div className='col-sm-3'>
                        <a
                          onClick={() => openBase64InNewTab(ref.FilePath)}
                          href="#"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ fontSize: 'small', marginLeft: '10px' }}
                        >
                          {ref.DocTitle}
                        </a>
                      </div>
                    );
                  })}

                </div>
              </div>
              {selectedConfig.ImageCapture && selectedConfig.ImageCapture == "enable" && <div className='mt-3'>
                <div className='row'>
                  <div className='col-sm-3'>
                    Capture Or Upload Images :
                  </div>
                  <div className='col-sm-9'>
                    <ImageView imageList={reportData.RefDocs.map(x => x.FilePath)} />
                  </div>
                </div>
              </div>}
            </div>
          }
          centered
          open={open}
          // onOk={() => {setOpen(false);handleApproval(true)}}
          onCancel={() => setOpen(false)}
          width={1000}
          footer={[
            <Button key="submit" type="primary" onClick={() => handleApproval('Preparing')}>
              Refer Back
            </Button>,
            <Button key="submit" type="primary" onClick={() => handleApproval('Closed')}>
              Approve
            </Button>,
            // <Button key="reject" type="danger" onClick={() => handleApproval(false)}>
            //   Reject
            // </Button>,
            <Button key="close" onClick={() => setOpen(false)}>
              Close
            </Button>
          ]}
        >
          <div className='relative'>
            <div className="accordion" id="accordionParent">
              {currentChecksheet && currentChecksheet.map((check, checkIdx) => AccordianComp(check, checkIdx))}
            </div>
          </div>
        </Modal>


      </div>

      {qualityData.length > 0 && <Table
        id="RejectionDetailedAnalysispiechart"
        // onSort={handleSort}
        columns={columns1}
        sortColumn={sortColumn}
        // data={extractInspectionDataSeparateArray(qualityData[0])}

        data={qualityData}
      />}
      {qualityData.length > 0 && <div className="float-end m-3">

        <PaginationComponent
          current={CurrentPage}
          pageSize={PageSize}
          totalItems={TotalPage * PageSize}  // or just use total count
          onPageChange={(page, size) => {
            if (size !== PageSize) setCurrentPage(1);
            else setCurrentPage(page);
            setPageSize(size);
          }}
        />
      </div>}

    </React.Fragment>
  );
}
export default QMSReportApproval;